import { useEffect, useState } from 'react';
import { artApi } from './api';

/** Is dit profiel de beheerder? Eén keer per sessie vragen; null = nog onbekend. */
let ask: Promise<boolean> | null = null;
let known: boolean | null = null;

export function useIsOwner(): boolean | null {
  const [ok, setOk] = useState<boolean | null>(known);
  useEffect(() => {
    if (known !== null) return;
    ask ??= artApi.config().then((c) => c.canManage).catch(() => false);
    void ask.then((v) => {
      known = v;
      setOk(v);
    });
  }, []);
  return ok;
}

/** Na wisselen van profiel opnieuw vragen. */
export function resetOwner(): void {
  ask = null;
  known = null;
}
